import React from "react";
import AdminNavContainer from "../../components/Admin/AdminNavContainer";

const AdminPortal = () => {
  return (
    <AdminNavContainer />
  )
}

export default AdminPortal